import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UserService } from '../../../service/user.service';
import { ToastrService } from 'ngx-toastr';
import { CognitoUserDto, UserPoolInfo } from '@clearing-hub/common';
import { BaxterAuthenticationService } from '@baxter-jenkins/authenticator';

@Component({
  selector: 'fxch-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  form: FormGroup;
  user: CognitoUserDto;
  userPoolInfo: UserPoolInfo;

  constructor(private readonly bsModalRef: BsModalRef,
              private readonly toastr: ToastrService,
              private readonly fb: FormBuilder,
              private readonly userService: UserService) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      email: new FormControl({value: this.user.email, disabled: true}),
      password: new FormControl(null, BaxterAuthenticationService.getPasswordValidations(this.userPoolInfo.passwordPolicy)),
      // passwordAgain: BaxterAuthenticationService.getPasswordValidations(),
      // password: new FormControl(),
      passwordAgain: new FormControl(null, BaxterAuthenticationService.getPasswordValidations(this.userPoolInfo.passwordPolicy))
    },
      {validators: BaxterAuthenticationService.passwordsMatched}
    );
  }

  submit() {
    if (this.form.invalid) {
      return;
    }
    const command = {
      email: this.user.email,
      password: this.form.value.password
    }
    this.userService.changeUserPassword(command).subscribe(() => {
      this.toastr.success('Password successfully changed');
      this.bsModalRef.hide();
    });
  }

  close() {
    this.bsModalRef.hide();
  }

}
